import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/src/store'

const initialState = {
    nationality: '',
    destination: '',
    visaType: '',
    processingSpeed: '',
    dateOfArrival: '',
    paxDetails: ''
}

const visaErrorSlice = createSlice({
    name: 'visaError',
    initialState,
    reducers: {
        setVisaErrorFields: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        }
    }
})

export const { setVisaErrorFields } = visaErrorSlice.actions
export const getVisaErrorFields = (state: RootState) => state.visaError
export default visaErrorSlice.reducer
